<ng-container [ngSwitch]="set">
  <span
    *ngSwitchCase="'typcn'"
    [ngClass]="{ 'icon-open': rotate === '180', 'icon-close': rotate == null }"
    class="icon typcn typcn-{{ name }}"
  ></span>
  <span
    *ngSwitchCase="'uil'"
    [ngClass]="{ 'icon-open': rotate === '180', 'icon-close': rotate == null }"
    class="icon uil uil-{{ name }}"
  ></span>
  <lucide-icon
    *ngSwitchCase="'lucide'"
    class="d-flex"
    [name]="name"
    [size]="size"
    [strokeWidth]="strokeWidth"
  ></lucide-icon>
  <i-tabler
    *ngSwitchCase="'tabler'"
    [name]="name"
    [style.width.px]="size"
    [style.height.px]="size"
  ></i-tabler>
</ng-container>
